import Select, { components } from 'react-select';
import styles from './MultiSelectDropdown.module.scss';
import { getDefaultSelectStyles } from './MultiSelectDropdown.constants';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Checkbox } from '../Checkbox';
const Option = (props) => {
  return (
    <components.Option {...props}>
      <Checkbox
        checked={props.isSelected}
        onChange={() => null}
        id={props.label}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};
export const MultiSelectDropdownComponent = ({
  options,
  value,
  onChange,
  isLoading,
  isDisabled,
  classNamePrefix,
  selectStyles,
  label,
  errorMessage,
  placeholder,
}) => {
  return (
    <div className={styles.dropdownContainer}>
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.label}
      >
        {label}
      </Text>
      <Select
        isMulti={true}
        options={options}
        value={value}
        onChange={onChange}
        isLoading={isLoading}
        isDisabled={isDisabled}
        placeholder={placeholder}
        classNamePrefix={classNamePrefix}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option }}
        styles={{
          ...getDefaultSelectStyles(selectStyles),
        }}
      />
      {!!errorMessage && (
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Regular}
          color="error-500"
        >
          {errorMessage}
        </Text>
      )}
    </div>
  );
};
